import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";
import Heroicon from "./Heroicon";

function SspUserAlert({ modalId }) {
  const [isOpen, setIsOpen] = useState(true);
  const [isIgnored, setIsIgnored] = useState(false);

  const ignoreModal = () => {
    axios
      .post("/modals/ignore", {
        modal_id: modalId,
      })
      .then(function (response) {})
      .catch(function (error) {});
  };

  const checkIsIgnored = () => {
    if (isIgnored) {
      ignoreModal();
    }
  };

  return (
    <Modal isOpen={isOpen} closeModal={() => true}>
      <div className="p-4 m-4 text-sm rounded-md sm:text-base alert alert--info">
        <Heroicon
          icon="o-information-circle"
          style="hidden sm:block mr-3 sm:w-24 sm:h-24"
        />
        <div>
          <p>
            Looks like your Castos account is connected to a WordPress site with
            our Seriously Simple Podcasting Plugin.
          </p>
          <p className="mt-2">
            To add a Podcast or Episode please create that content in WordPress
            first, and it will sync automatically to your Castos dashboard.
          </p>

          <div className="flex items-center gap-2 mt-4">
            <input
              type="checkbox"
              name="dismiss"
              id="dismiss"
              className="rounded"
              onChange={(e) => setIsIgnored(e.target.checked)}
            />
            <label htmlFor="dismiss" className="text-sm">
              Don't show this message again
            </label>
          </div>

          <a
            target="_blank"
            className="text-sm font-semibold mt-4 hover:underline flex items-center gap-2 w-[fit-content]"
            href="https://support.castos.com/article/101-castos-or-wordpress-where-should-i-publish-my-podcast"
          >
            Learn more
            <Heroicon icon="o-arrow-up-right" style="w-4 h-4" />
          </a>
          <a
            href="/podcast"
            className="text-sm block font-semibold mt-1 hover:underline w-[fit-content]"
          >
            Change settings
          </a>
        </div>
      </div>
      <div className="flex justify-between px-6 py-4 mt-6 bg-gray-200">
        <button
          className="btn-outlined btn-red"
          onClick={() => {
            setIsOpen(false);
            checkIsIgnored();
          }}
        >
          Ok, I still want to proceed
        </button>
        <a
          href="/podcasts"
          onClick={checkIsIgnored}
          className="btn-solid btn-dark"
        >
          Close
        </a>
      </div>
    </Modal>
  );
}

const initSspUserAlert = function (selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach((element) => {
      const root = createRoot(element);
      const modalId = element.dataset.modalid;
      root.render(<SspUserAlert modalId={modalId} />);
    });
  }
};

export { SspUserAlert as default, initSspUserAlert };
